<div class="p-d-flex p-flex-column">
  <div class="p-d-flex p-flex-column p-jc-center">
    <div class="step-subtitle">Korak 1</div>
    <div class="step-title">Odabir paketa</div>
  </div>

  <kodit-odabir-paketa-form2></kodit-odabir-paketa-form2>


  <!-- Dalje dugme -->
  <div class="p-d-flex p-jc-end p-mt-4" (click)="nextStep()">
    <div class="p-d-flex p-jc-center p-ai-center dalje-button">Dalje</div>
  </div>

</div>
